/* React core */
import { Component } from "react"
/* Redux binding */
import { connect } from "react-redux"
/* Router redirect */
import { Navigate } from "react-router-dom"
/* Session guard */
import { isTokenValid } from "./token"

/* Component ProtectedRoute */
class ProtectedRoute extends Component {

    componentDidMount = () => {
        if (!isTokenValid(this.props.token)) {
            if (this.props.token) {
                this.props.expire()
            }
            this.props.toggle(true)
        }
    }

    render = () => {
        if (!isTokenValid(this.props.token)) {
            return <Navigate to="/" replace />
        }
        return this.props.children
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        token: state.token
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        toggle: data => dispatch({ type: "TOGGLE_AUTH", payload: data }),
        expire: () => { dispatch({ type: "REMOVE_TOKEN" }); dispatch({ type: "REMOVE_USER" }) }
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute)
